import script from "./CongratsFuckOff.vue?vue&type=script&setup=true&lang=js"
export * from "./CongratsFuckOff.vue?vue&type=script&setup=true&lang=js"

import "./CongratsFuckOff.vue?vue&type=style&index=0&id=098379ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-098379ac"]])

export default __exports__